import { Routes } from '@angular/router';
import { authGuard } from './core/auth/auth.guard';
import { adminGuard } from './core/auth/admin.guard';

export const routes: Routes = [
    {
        path: '',
        loadChildren: () =>
            import('./features/landing-page/landing-page.routes').then(
                (m) => m.LANDINGPAGE_ROUTES
            ),
        title: 'Radiopharm — Home',
        pathMatch: 'full'
    },
    {
        path: 'home',
        loadChildren: () =>
            import('./features/dashboard/dashboard.routes').then(
                (m) => m.DASHBOARD_ROUTES
            ),
        title: 'Radiopharm - Dashboard',
        canMatch: [authGuard]
    },

    {
        path: 'contact',
        loadChildren: () =>
            import('./features/contact/contact.routes').then(
                (m) => m.CONTACT_CUSTOM_PLANS_ROUTES
            ),
        title: 'Contact - Custom Plan'
    },
    {
        path: 'construction-page',
        loadChildren: () =>
            import('./features/construction-page/construction-page.routes').then(
                (m) => m.CONTRUCTION_ROUTES
            ),
        title: 'Construction page'
    },
    {
        path: 'auth',
        loadChildren: () =>
            import('./features/auth/auth.routes').then((m) => m.AUTH_ROUTES),
    },
    {
        path: 'pay',
        canMatch: [authGuard],
        loadChildren: () =>
            import('./features/pay/pay.routes').then((m) => m.PAY_ROUTES)
    },
    {
        path: 'pago',
        canMatch: [authGuard],
        loadChildren: () =>
            import('./features/pay/pay.routes').then((m) => m.PAY_ROUTES)
    },
    {
        path: 'subscriptions',
        canMatch: [authGuard],
        loadChildren: () =>
            import('./features/subscriptions/subscriptions.routes').then(
                (m) => m.SUBSCRIPTIONS_ROUTES
            )
    },
    {
        path: 'profile',
        canMatch: [authGuard],
        loadChildren: () =>
            import('./features/profile/profile.routes').then(
                (m) => m.PROFILE_ROUTES
            ),
        title: 'Mi perfil'
    },
    {
        path: 'notifications',
        canMatch: [authGuard],
        loadChildren: () =>
            import('./features/notifications/notifications.routes').then(
                (m) => m.NOTIFICATIONS_ROUTES
            ),
        title: 'Notificaciones'
    },
    {
        path: 'history',
        canMatch: [authGuard],
        loadChildren: () =>
            import('./features/history/history.routes').then(
                (m) => m.HISTORY_ROUTES
            )
    },
    {
        path: 'dose-calculator',
        canMatch: [authGuard],
        loadChildren: () =>
            import('./features/dose-calculator/dose-calculator.routes').then(
                (m) => m.DOSE_CALCULATOR_ROUTES
            )
    },
    {
        path: 'radiopharmaceutical',
        canMatch: [authGuard],
        loadChildren: () =>
            import('./features/radiopharmaceutical/radiopharmaceutical.routes').then(
                (m) => m.RADIOPHARMACEUTICAL_ROUTES
            )
    },
    {
        path: 'admin',
        canMatch: [authGuard, adminGuard],
        loadChildren: () =>
            import('./features/admin/admin.routes').then((m) => m.ADMIN_ROUTES),
        title: 'Admin'
    },
    {
        path: '**',
        loadComponent: () =>
            import('./features/not-found/not-found.component').then(
                (m) => m.NotFoundComponent
            ),
        title: 'Not found'
    }
];
